import { on } from 'delegated-events';

const SELECTORS = Selectors({
  menu: '[data-menu]',
  buttons: '.hamburger-menu',
  navButton: '.mobile-link',
  header: '.header',
});

const fn = {
  init: () => {
    fn.bindEvents();
  },

  bindEvents: () => {
    on('click', SELECTORS.buttons, fn.handleClick);
    on('click', SELECTORS.navButton, fn.handleClick);
    document.addEventListener(
      'wheel',
      e => {
        fn.handleScroll(e);
      },
      {
        capture: true,
        passive: true,
      }
    );
  },

  handleClick: e => {
    e.preventDefault();

    let elm = document.querySelector(SELECTORS.menu);

    elm.classList.toggle('active');
  },

  handleScroll: e => {
    let elm = document.querySelector(SELECTORS.header);
    if (window.scrollY > 10) {
      elm.classList.add('fixed');
    } else {
      elm.classList.remove('fixed');
    }
  },
};

export default {
  can: () => true,
  run: fn.init,
};
